import { render } from "./ChatInputBox.vue?vue&type=template&id=101c4506&scoped=true"
import script from "./ChatInputBox.vue?vue&type=script&lang=js"
export * from "./ChatInputBox.vue?vue&type=script&lang=js"

import "./ChatInputBox.vue?vue&type=style&index=0&id=101c4506&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-101c4506"]])

export default __exports__